var _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6, _rect7, _circle, _path2, _rect8, _circle2, _circle3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifyId(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 56,
    viewBox: "0 0 70 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 12.8644,
    width: 60.8814,
    height: 41.8983,
    rx: 2,
    stroke: "#46485C",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.93213,
    y: 48.6441,
    width: 51.017,
    height: 2.37288,
    rx: 1.18644,
    fill: "#46485C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2203,
    y: 17.7966,
    width: 23.7288,
    height: 2.37288,
    rx: 1.18644,
    fill: "#46485C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2203,
    y: 22.5424,
    width: 23.7288,
    height: 2.37288,
    rx: 1.18644,
    fill: "#46485C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2203,
    y: 36.5606,
    width: 9.49153,
    height: 2.37288,
    rx: 1.18644,
    fill: "#46485C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4575 37.7471C47.4575 37.0918 47.9887 36.5606 48.644 36.5606H55.7626C56.4179 36.5606 56.949 37.0918 56.949 37.7471V37.7471C56.949 38.4023 56.4179 38.9335 55.7626 38.9335H48.644C47.9887 38.9335 47.4575 38.4023 47.4575 37.7471V37.7471Z",
    fill: "#46485C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.93213,
    y: 43.8983,
    width: 51.017,
    height: 2.37288,
    rx: 1.18644,
    fill: "#46485C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7.53845,
    y: 19.3846,
    width: 21.5385,
    height: 18.3077,
    rx: 2,
    fill: "#638DFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.3077,
    cy: 27.9231,
    r: 3.55769,
    fill: "#F8F8FF",
    stroke: "#46485C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3077 31.9808C21.3031 31.9808 23.8495 34.5584 24.0111 37.9262C23.9218 37.9377 23.8109 37.9486 23.6735 37.9583C22.8216 38.0187 21.2438 38.0192 18.3077 38.0192C15.3717 38.0192 13.7938 38.0187 12.942 37.9583C12.8046 37.9486 12.6937 37.9377 12.6043 37.9262C12.766 34.5584 15.3124 31.9808 18.3077 31.9808Z",
    fill: "#F8F8FF",
    stroke: "#46485C",
    strokeWidth: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.21155,
    y: 19.0577,
    width: 22.1923,
    height: 18.9615,
    rx: 3.25,
    stroke: "#46485C",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.356,
    cy: 13.6441,
    r: 13.6441,
    fill: "#5281FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.356,
    cy: 13.6441,
    r: 12.6441,
    stroke: "#46485C",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 9L56.5 7H57L61.5 9L62 10.5V12.5V14.5L61 16.5L59.5 18.5L56.5 20.5L55 20C54.5 19.5 53.4 18.5 53 18.5C52.6 18.5 51.5 16.5 51 15.5V12V9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5852 7.3075L56.559 5.965C56.4271 5.92109 56.2846 5.92109 56.1528 5.965L52.1266 7.3075C51.4864 7.52015 50.9296 7.92912 50.5351 8.47631C50.1407 9.0235 49.9287 9.68108 49.9293 10.3556V13.6441C49.9293 18.5045 55.8418 21.1889 56.095 21.3007C56.1771 21.3372 56.266 21.356 56.3559 21.356C56.4458 21.356 56.5346 21.3372 56.6168 21.3007C56.87 21.1889 62.7824 18.5045 62.7824 13.6441V10.3556C62.783 9.68108 62.5711 9.0235 62.1766 8.47631C61.7822 7.92912 61.2253 7.52015 60.5852 7.3075ZM61.4971 13.6441C61.4971 17.1498 57.4362 19.4492 56.3559 19.9993C55.2743 19.4511 51.2146 17.1588 51.2146 13.6441V10.3556C51.2147 9.95092 51.3421 9.5565 51.5787 9.22824C51.8154 8.89997 52.1494 8.65451 52.5334 8.52662L56.3559 7.25224L60.1784 8.52662C60.5623 8.65451 60.8963 8.89997 61.133 9.22824C61.3697 9.5565 61.4971 9.95092 61.4971 10.3556V13.6441Z",
    fill: "#46485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2839 12.3588H56.9986V11.0735C56.9986 10.903 56.9308 10.7396 56.8103 10.619C56.6898 10.4985 56.5263 10.4308 56.3559 10.4308C56.1855 10.4308 56.022 10.4985 55.9015 10.619C55.781 10.7396 55.7132 10.903 55.7132 11.0735V12.3588H54.4279C54.2575 12.3588 54.094 12.4265 53.9735 12.547C53.853 12.6675 53.7853 12.831 53.7853 13.0014C53.7853 13.1719 53.853 13.3353 53.9735 13.4559C54.094 13.5764 54.2575 13.6441 54.4279 13.6441H55.7132V14.9294C55.7132 15.0998 55.781 15.2633 55.9015 15.3838C56.022 15.5044 56.1855 15.5721 56.3559 15.5721C56.5263 15.5721 56.6898 15.5044 56.8103 15.3838C56.9308 15.2633 56.9986 15.0998 56.9986 14.9294V13.6441H58.2839C58.4543 13.6441 58.6178 13.5764 58.7383 13.4559C58.8588 13.3353 58.9265 13.1719 58.9265 13.0014C58.9265 12.831 58.8588 12.6675 58.7383 12.547C58.6178 12.4265 58.4543 12.3588 58.2839 12.3588Z",
    fill: "#5281FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.4237,
    height: 15.4237,
    fill: "white",
    transform: "translate(48.644 5.93222)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyId);
export default __webpack_public_path__ + "static/media/verify-id.fe73eab8.svg";
export { ForwardRef as ReactComponent };